// extracted by mini-css-extract-plugin
export var copyableField = "_lz-4";
export var customerBadge = "_lz-0";
export var customerInfoTitle = "_lz-2";
export var details = "_lz-1";
export var dropdownContainer = "_lz-5";
export var dropdownImage = "_lz-6";
export var editAssigneeForm = "_lz-a";
export var editButton = "_lz-3";
export var email = "_lz-7";
export var hidden = "_lz-d";
export var input = "_lz-8";
export var saveButton = "_lz-b";
export var shopifyIcon = "_lz-c";
export var suggestionBadge = "_lz-e";
export var suggestionText = "_lz-f";
export var username = "_lz-9";